const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export async function copyTableToClipboard({
  columns,
  rows,
  getCellValue,
  includeHeader = true,
}) {
  const html = `
      <table>
        ${
          includeHeader
            ? `
        <thead>
          <tr>
            ${columns.map((c) => `<th>${escapeHtml(c.Header)}</th>`).join("")}
          </tr>
        </thead>`
            : ""
        }
        <tbody>
          ${rows
            .map(
              (row) => `
            <tr>
              ${columns
                .map(
                  (col) =>
                    `<td>${escapeHtml(getCellValue(row, col) ?? "")}</td>`
                )
                .join("")}
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>
      `;

  const text =
    (includeHeader ? columns.map((c) => c.Header).join("\t") + "\n" : "") +
    rows
      .map((r) => columns.map((c) => getCellValue(r, c) ?? "").join("\t"))
      .join("\n");

  await navigator.clipboard.write([
    new ClipboardItem({
      "text/html": new Blob([html], { type: "text/html" }),
      "text/plain": new Blob([text], { type: "text/plain" }),
    }),
  ]);
}